import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import useAuthentication from 'v3/hooks/useAuthentication';
import { RoutesEnum } from 'v3/routes/enum';

interface AuthProps {
  redirectTo: string;
}

export const Auth = ({ redirectTo }: AuthProps) => {
  const { isLoggedin } = useAuthentication();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isRouteAuth = pathname.includes(RoutesEnum.Auth);

  if (isLoggedin && isRouteAuth) {
    navigate(redirectTo);
  }
  return <Outlet />;
};
